import styled from "styled-components";
import { TextField } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";

import { TextFieldProps } from "./TextFieldProps";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

export const StyledFormHelperText = styled(FormHelperText)`
    font-family: Mulish !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    line-height: 15px !important;
    color: ${({ error }) => (error ? UIStyleConstants.RED_DARK_COLOR : UIStyleConstants.TEXT_COLOR_DEFAULT)} !important;
    margin-top: 6px !important;
`;

export const StyledTextField = styled(TextField)`
    width: ${(props: TextFieldProps) => props.width} !important;
    box-sizing: border-box !important;
    z-index: 1 !important;

    fieldset {
        border: none !important;
    }

    label {
        padding: 0 5px;
        background-color: ${({ customstyle }) => (customstyle === "outlined" ? UIStyleConstants.WHITE_COLOR : "unset")};
        top: ${({ ispicker, error }) => (ispicker === "true" && error ? "-12px" : "0px")};
    }

    input {
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
        border-radius: 5.65107px;
        padding-left: ${({ customstyle }) => (customstyle !== "standard" ? "20px" : "0px")};
        padding-right: ${({ customstyle }) => (customstyle !== "standard" ? "20px" : "0px")};
        background-color: ${({ customstyle }) =>
            customstyle === "filled" ? UIStyleConstants.GRAY_VERY_LIGHT_COLOR : "unset"};

        &:focus {
            border: ${({ customstyle }) =>
                    customstyle === "filled" || customstyle === "standard" ? "0px" : "1.35302px"}
                solid ${({ error }) => (error ? UIStyleConstants.RED_DARK_COLOR : UIStyleConstants.BLUE_GRAY_COLOR)};
        }

        border: ${({ customstyle }) => (customstyle === "filled" || customstyle === "standard" ? "0px" : "1.35302px")}
            solid ${({ error }) => (error ? UIStyleConstants.RED_DARK_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR)};
    }

    .MuiOutlinedInput-adornedStart,
    .MuiFilledInput-adornedStart {
        border: ${({ customstyle }) => (customstyle === "filled" || customstyle === "standard" ? "0px" : "1.35302px")}
            solid ${({ error }) => (error ? UIStyleConstants.RED_DARK_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR)};

        input,
        textarea {
            border: none;
            padding-left: 0px;
        }
    }

    input[type="number"]:not([step="1"]) {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        -moz-appearance: textfield;
    }

    textarea {
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
        border-radius: 5.65107px;
        padding-top: ${({ variant }) => (variant === "outlined" ? "15px" : "0px")};
        padding-bottom: ${({ variant }) => (variant === "outlined" ? "15px" : "0px")};
        padding-left: ${({ customstyle }) => (customstyle !== "standard" ? "20px" : "0px")};
        padding-right: ${({ customstyle }) => (customstyle !== "standard" ? "20px" : "0px")};
        background-color: ${({ customstyle }) =>
            customstyle === "filled" ? UIStyleConstants.GRAY_VERY_LIGHT_COLOR : UIStyleConstants.WHITE_COLOR};

        &:focus {
            border: ${({ customstyle }) =>
                    customstyle === "filled" || customstyle === "standard" ? "0px" : "1.35302px"}
                solid ${({ error }) => (error ? UIStyleConstants.RED_DARK_COLOR : UIStyleConstants.BLUE_GRAY_COLOR)};
        }

        border: ${({ customstyle }) => (customstyle === "filled" || customstyle === "standard" ? "0px" : "1.35302px")}
            solid ${({ error }) => (error ? UIStyleConstants.RED_DARK_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR)};
    }

    .MuiOutlinedInput-multiline {
        padding: 0px;
    }

    .MuiFormLabel-root.Mui-focused {
        top: 0px;
        color: ${({ error }) => (error ? UIStyleConstants.RED_DARK_COLOR : UIStyleConstants.BLUE_COLOR)};
    }

    .MuiFilledInput-underline:after,
    .MuiInput-underline:after {
        border-bottom: 1px solid ${UIStyleConstants.BLUE_COLOR};
    }

    .MuiFilledInput-underline:before,
    .MuiInput-underline:before {
        border-bottom: 1px solid ${UIStyleConstants.GRAY_COLOR};
        opacity: 0.3;
    }

    .MuiFilledInput-root,
    .MuiFilledInput-root:hover {
        background-color: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    }

    .MuiFilledInput-multiline {
        padding-left: 0px;
        padding-right: 0px;
    }

    .MuiOutlinedInput-adornedEnd {
        position: relative;
        padding-right: 0px;

        button {
            position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);
        }
    }
` as React.ComponentType<TextFieldProps>;

export const ChildFullWidthDiv = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;

    > * {
        width: 100%;
        margin-bottom: 10px !important;
    }
`;
